import styled from "@emotion/styled";
import { Slider } from "@mui/material";
import { getContrastColor } from "../risk/bottombar/LegendStyle";
import { BORDER_STYLE, StyledButton } from "../risk/bottombar/AdditionalActionsStyle";

export const CustomSlider = styled( Slider )( {
    width: "60%",
    "& .MuiSlider-thumb": {
        width: 10,
        height: 10,
    },
    position: "relative",
    padding: "5px !important",
    marginLeft: "5px",
    zIndex: 10,
} );

export const SliderContainer = styled( "div" )( {
    position: "relative",
    display: "inline-block",
} );

/**
 * Styled component for the opacity toggle buttons
 * The button's background color is dynamically set based on the risk level.
 *
 * @param riskColor - The background color of the button based on the risk level.
 */
export const StyledOpacityButton = styled( StyledButton, { shouldForwardProp: ( prop: string ) => prop !== "isVisible" } )<{ hexbackgroundcolor: string, isVisible: boolean }>(
    ( { hexbackgroundcolor, isVisible } ) => ( {
        backgroundColor: isVisible ? hexbackgroundcolor : "transparent",
        color: isVisible ? getContrastColor( hexbackgroundcolor ) : "black",
        flex: "1",
        minWidth: "38px",
        paddingLeft: "12px",
        fontFamily: "Arial"
    } )
);

/**
 * A styled container for the impact layer opacity toggles
 */
export const OpacityToggleContainer = styled.div( {
    display: "flex",
    flexDirection: "row",
} );

/**
 * A container for opacity actions, including modify the overall opacity
 * and disabling individual impact layers
 */
export const OpacityActionsContainer = styled( "div" )( {
    display: "flex",
    flexDirection: "column",
    border: BORDER_STYLE,
    borderRadius: "10px",
    background: "white",
    margin: "20px 20px 20px 20px"
} );
